module.exports = __webpack_public_path__ + "img/icon-remove.f28f487d.svg";